<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-12-20 17:08:19
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-04-11 13:40:18
-->
<template>
  <div class="innovative innovative-accuctp" ref="accuctp">
    <div class="innovative-bj scrollBox">
      <img class="wid100" :src="require('@/assets/images/m/innovate/product-list-bj.png')" alt="" srcset="">
      <div class="innovative-bj-title center_up_down_left_right" v-html="$t('product.accuctp.title')"></div>
    </div>
    <div class="overhid p-b-30">
      <div class="p-30 p-t-40 p-b-20">
        <div class="innovative-item-title p-l-25" v-html="$t('product.accuctp.list[0].title')"></div>
      </div>
      <div class="p-l-5 p-r-5">
        <img class="wid100" :src="$t('product.accuctp.list[0].img')" alt="" srcset="">
      </div>
      <div class="p-l-30 p-r-30 p-t-15 textj">
        <p v-for="item, index in $t('product.accuctp.list[0].des')" :key="index" v-html="item"></p>
      </div>
    </div>
    <div>
      <div class="accuctp-characteristics">
        <div class="innovative-container">
          <div class="innovative-item-title" v-html="$t('product.accuctp.list[1].title')"></div>
          <div class="accuctp-characteristics-box">
            <div class="p-t-20 p-b-30" v-for="item, index in $t('product.accuctp.list[1].des')" :key="index">
              <div class="flex justify_content_center p-b-15 textc">
                <img class="accuctp-characteristics-img" :src="item.img" alt="" srcset="">
              </div>
              <div class="innovative-wrap-item-title fz-30 p-b-25 textc" v-html="item.title"></div>
              <div v-if="language == 'en'">
                <p class="innovative-characteristics-item" v-for="$item, $index in item.list" :key="$index" v-html="$item"></p>
              </div>
              <div v-else class="textc">
                <p v-for="$item, $index in item.list" :key="$index" v-html="$item"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="accuctp-advantages innovative-container">
      <div class="innovative-item-title widauto ilblk p-r-100"  v-html="$t('product.accuctp.list[2].title')"></div>
      <div class="">
        <img class="wid100" :src="$t('product.accuctp.list[2].img')" alt="" srcset="">
      </div>
    </div>
    <div class="innovative-container">
      <div class="p-t-20 article">
        <div class="innovative-item-title" v-html="$t('product.accuctp.article.title')"></div>
        <div class="p-t-15">
          <p class="p-t-15" v-for="item, index in $t('product.accuctp.article.des')" :key="index" v-html="`${index + 1}. ${item}`"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['language'])
  }
}
</script>

<style lang="less">
@import "~@/styles/m/products.less";
</style>

<style lang="less" scoped>
.m .innovative-accuctp {
  .accuctp-characteristics {
    background-image: url('~@/assets/images/innovate/AccuCTP/m_2.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: top;
    padding: 20px 0;
    .accuctp-characteristics-box {
      background: #FFFFFF;
      box-shadow: 0px 4px 12px 4px rgba(81,170,255,0.1);
      padding: 50px 30px 30px 30px;
    }
    .accuctp-characteristics-img {
      max-height: 73px;
    }
  }
}
</style>
